import type { SelectedUnits } from '../../../../shared/domain/flows'

export const isUnitArray = (value: SelectedUnits): value is number[] => {
    return Array.isArray(value) && value.every((entry) => typeof entry === 'number')
}
